import { createSlice } from "@reduxjs/toolkit";
import ApiServices from "@/api/apexchat.api.services";
import { signinApi, signupAPI } from "@/api/endpoints";

const initialBusinessDetailsState = {
  businessName: "",
  businessWebsite: "",
  businessCategory: "",
  businessPhone: "",
  businessPhoneCountryCode: "",
  businessPhoneCountryISOCode: "",
  phoneVerified: false,
  businessCategories: [],
};

const initialAccountDetailsState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
};

export const signupSlice = createSlice({
  name: "signup",
  initialState: {
    signup: {
      businessDetails: initialBusinessDetailsState,
      accountDetails: initialAccountDetailsState,
    },
  },
  reducers: {
    setBusinessCategories: (state, action) => {
      state.signup.businessDetails.businessCategories = action.payload;
    },
    setBusinessDetailsState: (state, action) => {
      state.signup.businessDetails = {
        ...state.signup.businessDetails,
        ...(action.payload || {}),
      };
    },
    resetBusinessDetailsState: (state) => {
      state.signup.businessDetails = initialBusinessDetailsState;
    },
    setAccountDetailsState: (state, action) => {
      state.signup.accountDetails = {
        ...state.signup.accountDetails,
        ...(action.payload || {}),
      };
    },
    resetAccountDetailsState: (state) => {
      state.signup.accountDetails = initialAccountDetailsState;
    },
  },
});

export const {
  setBusinessCategories,
  setBusinessDetailsState,
  resetBusinessDetailsState,
  setAccountDetailsState,
  resetAccountDetailsState,
} = signupSlice.actions;

export const selectSignupBusinessDetails = (state) =>
  state?.signup?.signup?.businessDetails || initialBusinessDetailsState;

export const selectpBusinessCategories = (state) =>
  state?.signup?.signup?.businessDetails?.businessCategories || [];

export const selectSignupAccountDetails = (state) =>
  state?.signup?.signup?.accountDetails || initialAccountDetailsState;

export default signupSlice.reducer;

export const createSignupWithEmail = (payload) =>
  ApiServices.postPublic(signupAPI.signUpWithEmail, payload);

export const sendOTPPhone = (payload) =>
  ApiServices.postPublic(signupAPI.sendOTPPHone, payload);

export const verifyOTPPhone = (payload) =>
  ApiServices.postPublic(signupAPI.verifyOTPPhone, payload);

export const resendVerificationEmail = (payload) =>
  ApiServices.postPublic(signupAPI.resendVerifyEmail, payload);

export const signupwithGoogle = (payload) =>
  ApiServices.postPublic(signupAPI.signupwithGoogle, payload);

export const getBusinessCategories = () =>
  ApiServices.getPublic(signupAPI.getBusinessCategories);

export const signIn = () =>
  ApiServices.postPublic(signinApi.signIn);

export const signInCallback = (code) =>
  ApiServices.getPublic(signinApi.callback(code));

export const signupGoogleCallback = ({ code, state }) =>
  ApiServices.getPublic(signupAPI.signupwithGoogleCallback(code, state));

export const updateSignupUser = (payload) =>
  ApiServices.putPublic(signupAPI.updateSignupUser(payload.userId), payload.data);
